import {useAuth0, User} from "@auth0/auth0-react";
import React, {useEffect, useState, useRef, JSX} from "react";
// @ts-ignore TODO ts-ignore
import {LeadManagement} from "./LeadManagement/LeadManagement.js";
// @ts-ignore TODO ts-ignore
import {ZapleczeHeader} from "./ZapleczeHeader";
import axios from "axios";
// @ts-ignore TODO ts-ignore
import {getUrl} from "../requests";
import GlobalStyles from "@mui/material/GlobalStyles";
// @ts-ignore TODO ts-ignore
import ZapleczeHeaderBar, {ZapleczeHeaderBarProps} from "./ZapleczeHeaderBar";
// @ts-ignore TODO ts-ignore
import {CompanyProfileCardsPanel} from "./WorkPanel/CompanyProfileCardsPanel";
// @ts-ignore TODO ts-ignore
import {ZapleczeAdmin} from "./WorkPanel/ZapleczeAdmin";
import css from './Zaplecze.module.css'
import Profile from "./Model/Profile";
import clsx from "clsx";
import LeadToolbar from "./LeadManagement/LeadToolbar";
// @ts-ignore TODO ts-ignore
import {
    ZapleczeGoodMapHeader, ZapleczeGoodMapHeaderProps,
    ZapleczeGoodMapPanel, ZapleczeGoodMapPanelProps,
    ZapleczeGoodMapToolbar, ZapleczeGoodMapToolbarProps
} from "./GoodMap/ZapleczeGoodMapParts.tsx";
import {GoodFilterInterface} from "./Model/GoodFilter";
import dayjs from "dayjs";
import LeadFilter from "./Model/LeadFilter.ts";
import {ZapleczeMenu} from "./ZapleczeMenu";
import Box from "@mui/material/Box";
import MenuConst, {MenuProps} from "./MenuConst.ts";
import {HorizontalMenuRef} from "./HorizontalMenu.tsx";
import {DEF} from "../const.ts";

// @ts-ignore TODO ts-ignore
const Zaplecze = () => {
    // Główne menu na zapleczu, które zależy od kontekstu.
    const [contextMenu, setContextMenu] = useState<{option:number, name:string}>({
        option: ZapleczeMenu.OBSLUGA_LEADOW,
        name: ZapleczeMenu.OBSLUGA_LEADOW_STR,
    });
    const [pageTitle, setPageTitle] = useState<string>(ZapleczeMenu.OBSLUGA_LEADOW_STR)
    const [isFetching, setIsFetching] = useState<boolean>(false);
    const [idToken, setIdToken] = useState<string>('');
    const [openInProgress, setOpenInprogress] = useState<boolean>(false);
    const [selectedContext, setSelectedContext] = useState<string>('');
    const [profile, setProfile] = useState<Profile>((): Profile => {
        return new Profile("", "");
    });

    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [menuIx, setMenuIx] = useState<number>(MenuConst.NONE);
    const menuProps: MenuProps = {
        isAdmin: isAdmin,
        setMenuIx: setMenuIx,
    }
    const isFirstRender = useRef(true);

    useEffect((): void => {
        if (selectedContext === "ADMIN") {
            setProfile(new Profile("ADMIN", ""));
            setContextMenu({
                option: ZapleczeMenu.OBSLUGA_LEADOW,
                name: ZapleczeMenu.OBSLUGA_LEADOW_STR,
            })
        }
    }, [selectedContext])

    // @ts-ignore TODO ts-ignore
    const [placeDetails, setPlaceCDetails] = React.useState({
        lng: localStorage.getItem("lng"),
        lat: localStorage.getItem("lat"),
        city: localStorage.getItem("city"),
        cityId: localStorage.getItem("cityId"),
        apiKey: localStorage.getItem("ApiKey"),
    })

    const {isAuthenticated, isLoading, getIdTokenClaims, logout, user} = useAuth0<User>();

    const [epidMap, setEpidMap] = useState({"": ""});

    // @ts-ignore TODO ts-ignore
    const fetchEpidContext = (token): void => {

        setIsFetching(true);
        axios
            .get(`${getUrl()}/api/v1/profile/context`, {
                headers: {Authorization: `Bearer ${token}`},
            })
            .then((res) => {
                const data = res.data;

                // @ts-ignore TODO ts-ignore
                if (!data.epids && !data.privileges.some(obj => obj.hasOwnProperty("edit"))) {
                    alert('Nie masz uprawnień do tej alikacji, za chwile zostaniesz wylogowany z systemu i przekierowany na stronę główną.');
                    logout({
                        logoutParams: {returnTo: `${window.location.origin}`},
                    });
                }
                if (data.epids) {
                    // @ts-ignore TODO ts-ignore
                    localStorage.setItem("isAdmin", true);
                    setIsAdmin(true);
                    // @ts-ignore TODO ts-ignore
                    window.isAdmin = true;
                } else {
                    // @ts-ignore TODO ts-ignore
                    localStorage.setItem("isAdmin", false);
                    setIsAdmin(false);
                    // @ts-ignore TODO ts-ignore
                    window.isAdmin = false;
                }

                const contextList = (() => {
                    if (data.epids) {
                        // @ts-ignore TODO ts-ignore
                        const epids = Object.entries(data.epids).map(([epid, _profileId]) => {
                            return epid
                        }, []);
                        setEpidMap(Object.assign({}, {"ADMIN": ""}, data.epids));
                        return ["ADMIN", ...epids];
                    } else {
                        // @ts-ignore
                        return data.privileges.map(el => el.edit ? el.edit : "") ?? [];
                    }
                })();

                setSelectedContext(contextList[0])
                setIsFetching(false);

            })
            .catch((err) => {
                console.log(err);
                setIsFetching(false);
                if (err.response.status === 401 || err.response.status === 500 || err.response.status === 403) {
                    alert('Twoja sesja wygasła, za chwile zostaniesz wylogowany z systemu i przekierowany na stronę główną. Aby ponownie skorzystać z systemu musisz się ponownie zalogować ');
                    logout({
                        logoutParams: {returnTo: `${window.location.origin}`},
                    });
                }

            });
    };

    //-----------------------------------------------------------
    // Toolbar tytułowy

    const drawZapleczeHeaderBar = (): JSX.Element => {
        const props: ZapleczeHeaderBarProps = {
            isProvider: !isAdmin,
            isAdmin,
            user,
            contextList: Object.keys(epidMap),
            epidMap,
            setSelectedContext,
            selectedContext,
            // @ts-ignore TODO ts-ignore
            drawerItemClickHandler: (index:number, text:string):void => setContextMenu({option: index, name: text})
        }

        return (
            <ZapleczeHeaderBar {...props}/>
        );
    }

    // Toolbar tytułowy
    //-----------------------------------------------------------


    //-----------------------------------------------------------
    // Obsługa leadów
    const initialLeadFilter: LeadFilter = {
        dateCreateFrom: DEF.DEFAULT_DATE_FROM,
        dateCreateTo: DEF.DEFAULT_DATE_TO,
        dateUpdateFrom: DEF.DEFAULT_DATE_FROM,
        dateUpdateTo: DEF.DEFAULT_DATE_TO,
        installationAddress: null,
        status: null,
        epid: null,
    };

    const [leadFilter, setLeadFilter] = useState(initialLeadFilter);
    const [leadFilterReady, setLeadFilterReady] = useState(false);
    useEffect((): void => {
        console.log("leadFilter:", leadFilter);
    }, [leadFilterReady])


    const drawLeadHeader = (): JSX.Element => {
        return (
            <ZapleczeHeader pageTitle={pageTitle}
                // @ts-ignore TODO ts-ignore
                            user={user.name}
                            contextList={epidMap}
                            setSelectedContext={setSelectedContext}
                            selectedContext={selectedContext}
                            isAdmin={isAdmin}
            />
        )
    }

    const drawLeadToolbar = (): JSX.Element => {
        return (
            <LeadToolbar profile={profile}
                         token={idToken}
                         leadFilter={leadFilter}
                         setLeadFilter={setLeadFilter}
                         filterReady={leadFilterReady}
                         setFilterReady={setLeadFilterReady}
            />
        );
    }

    const drawLeadMain = (): JSX.Element => {
        return (
            <Box className={clsx(css.main)}>
                <Box
                    sx={{height: "90%"}}
                >
                    <LeadManagement profile={profile}
                                    token={idToken}
                                    auth={idToken}
                                    context={selectedContext}
                                    filter={leadFilter}
                                    setLeadFilter={setLeadFilter}
                                    filterReady={leadFilterReady}
                                    setFilterReady={setLeadFilterReady}
                    />
                </Box>

            </Box>
        )
    }

    // Obsługa leadów
    //-----------------------------------------------------------

    //-----------------------------------------------------------
    // Obsługa dóbr

    // @ts-ignore
    const initialGoodFilter: GoodFilterInterface = {
        description: null,
        dateFrom: dayjs().subtract(3, 'month').startOf('month'),
        dateTo: dayjs().endOf("day"),
        goodAddress: null,
        pointsFrom: null,
        pointsTo: null,
        goodStage: null
    };

    const [goodFilter, setGoodFilter] = useState(initialGoodFilter);
    const [goodFilterReady, setGoodFilterReady] = useState(false);
    const menuRef = useRef<HorizontalMenuRef>(null);

    useEffect((): void => {
        if (selectedContext === "ADMIN") {
            setGoodFilter({
                ...initialGoodFilter,
                epid: "",
            });
        } else {
            setGoodFilter({
                ...initialGoodFilter,
                epid: selectedContext,
            });
        }
    }, [selectedContext])

    useEffect((): void => {
        console.log("goodFilter:", goodFilter);
    }, [goodFilterReady])

    const drawGoodMapHeader = (): JSX.Element => {
        const headerProps: ZapleczeGoodMapHeaderProps = {
            menuProps: menuProps,
            pageTitle,
            menuRef
        }

        return (
            <ZapleczeGoodMapHeader {...headerProps}/>
        )
    }

    const drawGoodMapToolbar = (): JSX.Element => {
        const toolbarProps: ZapleczeGoodMapToolbarProps = {
            profile,
            menuIx,
            token: idToken,
            filter: goodFilter,
            setFilter: setGoodFilter,
            filterReady: goodFilterReady,
            setFilterReady: setGoodFilterReady
        }

        return (
            <ZapleczeGoodMapToolbar {...toolbarProps}/>
        )
    }

    const drawGoodMapMain = (): JSX.Element => {

        const props:ZapleczeGoodMapPanelProps = {
            profile,
            isAdmin,
            auth: {
                user: idToken,
                epid: selectedContext,
            },
            openInProgress: openInProgress,
            setOpenInProgress: setOpenInprogress,
            filter: goodFilter,
            setFilter: setGoodFilter,
            filterReady: goodFilterReady,
            setFilterReady: setGoodFilterReady,

            menuIx,
            setMenuIx,

            sessionId: placeDetails.cityId, // TODO Czemu sessionId brane z cityId ??
            apiKey: placeDetails.apiKey,
            lng: placeDetails.lng,
            lat: placeDetails.lat,
            city: placeDetails.city,
            cityId: placeDetails.cityId,
            menuRef: menuRef

        }

        return (
            <ZapleczeGoodMapPanel {...props}/>

        )
    };

    // Obsługa dóbr
    //-----------------------------------------------------------


    const drawCompanyProfileCardsMain = (): JSX.Element => {

        return (
            <>
                <CompanyProfileCardsPanel profile={profile}
                                          token={idToken}
                                          pageTitle={pageTitle}
                                          contextList={epidMap}
                                          setSelectedContext={setSelectedContext}
                                          selectedContext={selectedContext}
                                          setOpenInProgress={setOpenInprogress}
                                          isAdmin={isAdmin}
                />
            </>
        );
    }

    const drawAdminMain = (): JSX.Element => {
        return (
            <>
                <ZapleczeAdmin token={idToken}
                               pageTitle={pageTitle}
                    // @ts-ignore TODO ts-ignore
                               user={user.name}
                               contextList={epidMap}
                               isAdmin={isAdmin}
                               setSelectedContext={setSelectedContext}
                               selectedContext={selectedContext}
                />
            </>
        )

    }

    useEffect((): void => {

        getIdTokenClaims().then(claims => {
            // @ts-ignore TODO ts-ignore
            setIdToken(claims.__raw);
            // @ts-ignore TODO ts-ignore
            fetchEpidContext(claims.__raw);
        }).catch(err => {
            console.debug("Something went wrong", err);
        })

    }, []);

    useEffect(() => {
        setPageTitle(contextMenu.name);
    }, [contextMenu.option])

    useEffect((): void => {
        setIsAdmin("ADMIN" === selectedContext);
        // @ts-ignore TODO ts-ignore
        setProfile(new Profile(selectedContext, epidMap[selectedContext]));

        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        if (profile.getEpid() === "ADMIN" && contextMenu.option === ZapleczeMenu.FIRMA) {
            setContextMenu({
                option: ZapleczeMenu.OBSLUGA_LEADOW,
                name: ZapleczeMenu.OBSLUGA_LEADOW_STR,
            })
        } else if (profile.getEpid() !== "ADMIN" && contextMenu.option === ZapleczeMenu.ADMIN) {
            setContextMenu({
                option: ZapleczeMenu.FIRMA,
                name: ZapleczeMenu.FIRMA_STR,
            })
        }

    }, [selectedContext]);

    if (isLoading) {
        return <div>Loading ...</div>;
    }

    if (isFetching) {
        return <div>Ładuje dane ...</div>;
    } else {

        if (isAuthenticated && idToken) {

            return (
                <>
                    <GlobalStyles
                        styles={{
                            body: {
                                background: "none",
                                animation: "none",
                            },
                        }}
                    />

                    <Box className={css.zaplecze}>

                        <Box className={clsx(css.topBar)}>
                            {drawZapleczeHeaderBar()}
                        </Box>

                        {/*------------------------------------------------------*/}

                        <Box className={clsx(css.header)}>

                            {ZapleczeMenu.OBSLUGA_LEADOW === contextMenu?.option && drawLeadHeader()}

                            {ZapleczeMenu.MAPA_DOBRA === contextMenu?.option && drawGoodMapHeader()}

                        </Box>

                        <Box className={clsx(css.workPanel)}>

                            <Box className={clsx(css.toolbar, isAdmin ? css.toolbarShow : css.toolbarHide)}>

                                {ZapleczeMenu.OBSLUGA_LEADOW === contextMenu?.option && drawLeadToolbar()}

                                {ZapleczeMenu.MAPA_DOBRA === contextMenu?.option && drawGoodMapToolbar()}

                            </Box>

                            <Box className={clsx(css.main, isAdmin ? css.mainWithToolbar : css.mainWithoutToolbar)}>

                            {ZapleczeMenu.OBSLUGA_LEADOW === contextMenu?.option && drawLeadMain()}

                                {ZapleczeMenu.MAPA_DOBRA === contextMenu?.option && drawGoodMapMain()}

                                {ZapleczeMenu.FIRMA === contextMenu?.option && drawCompanyProfileCardsMain()}

                                {ZapleczeMenu.ADMIN === contextMenu?.option && isAdmin && drawAdminMain()}

                            </Box>
                        </Box>
                    </Box>
                </>
            );
        } else {
            return "Nie jesteś zautentykowany !!!!"
        }

    }
}
export default Zaplecze

